import { SelectItem } from "primeng/api";
import * as e from "../_generated/enums";
import { EnumTypeDto, CountryDto } from "../_generated/models";
import { ReferenceController } from "../_generated/services";
import { Functions } from "./Functions";

export class LookUps {
  public static EnumList: EnumTypeDto[];
  public static EnumType: EnumTypeDto;
  public static CountryList: CountryDto[];

  public static getEnumByName(enumName: string): EnumTypeDto {
    if (LookUps.EnumList !== undefined)
      return LookUps.EnumList.find(v => v.Name === enumName);
  }

  public static getEnumValue(e: string, id: number): string {
    if (!e || !id) {
      return undefined;
    }

    let lu = LookUps.getEnumByName(e);
    let eenum = lu.EnumValues.find(x => x.Id === id);

    return eenum ? eenum.Value : undefined;
  }

  public static getCountryById(id) {
    return LookUps.CountryList.find(country => country.Id === id);
  }

  public static getCountryByIso(isoCode) {
    return LookUps.CountryList.find(country => country.IsoCode === isoCode);
  }

  public static getEnumValuesForDropdown(en, ...excludedValues): SelectItem[] {
    if (LookUps.EnumList !== undefined) {
      const result: SelectItem[] = [];

      LookUps.EnumType = this.getEnumByName(en);
      try {
        LookUps.EnumType.EnumValues.forEach(item => {
          if (!(excludedValues.indexOf(item.Id) >= 0)) {
            result.push({
              value: item.Id,
              label: item.Value
            });
          }
        });
      } catch (error) { }

      return result;
    }
  }

  public static getActiveEnumValuesForDropdown(en, ...excludedValues): SelectItem[] {
    if (LookUps.EnumList !== undefined) {
      const result: SelectItem[] = [];

      LookUps.EnumType = this.getEnumByName(en);
      try {
        LookUps.EnumType.EnumValues.forEach(item => {
          if (!(excludedValues.indexOf(item.Id) >= 0) && item.Description.split("|")[2].toLowerCase() == 'true') {
            result.push({
              value: item.Id,
              label: item.Value
            });
          }
        });
      } catch (error) { }

      return result;
    }
  }

  public static getEnumValuesForNgMultiselect(en, isGroup): any[] {
    if (LookUps.EnumList !== undefined) {
      const result: any[] = [];

      LookUps.EnumType = this.getEnumByName(en);
      try {
        LookUps.EnumType.EnumValues.forEach(item => {
          if (item.Id !== 0 && item.Id !== -99) {
            let newItem: any = {
              Key: item.Id,
              Value: item.Value
            };
            if (isGroup) {
              newItem.Description = item.Description;
            }

            result.push(newItem);
          }
        });
      } catch (error) {
       }

      return result;
    }
  }

  public static getYesNoLu(): SelectItem[] {
    const YesNo: SelectItem[] = [];
    YesNo.push({ value: true, label: "Yes" });
    YesNo.push({ value: false, label: "No" });

    return YesNo;
  }

  public static getTrueFalseLu(): SelectItem[] {
    const TrueFalse: SelectItem[] = [];
    TrueFalse.push({ value: true, label: "True" });
    TrueFalse.push({ value: false, label: "False" });

    return TrueFalse;
  }

  public static getColumnTypesLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown("eColumnType");
  }

  public static getGridAreasLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown("eGridArea");
  }

  public static getDealNoteTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealBookingNoteType",
      e.eDealBookingNoteType.Not_Set,
      e.eDealBookingNoteType.DataError
    );
  }

  public static getDepartmentsLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDepartment",
      e.eDepartment.DataError,
      e.eDepartment.Not_Set
    );
  }

  public static getRegionsLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eRegion",
      e.eRegion.DataError,
      e.eRegion.Not_Set
    );
  }

  public static getCountriesLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eCountry",
      e.eCountry.Not_Set,
      e.eCountry.DataError
    );
  }

  public static getCompanyLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBuyerCompanyType",
      e.eBuyerCompanyType.Not_Set,
      e.eBuyerCompanyType.DataError
    );
  }

  public static getPaymentTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealPaymentType",
      e.eDealPaymentType.Not_Set,
      e.eDealPaymentType.DataError
    );
  }

  public static getParticipantTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eClientParticipantType",
      e.eClientParticipantType.Not_Set,
      e.eClientParticipantType.DataError
    );
  }

  public static getPaymentStatusLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealPaymentStatus",
      e.eDealPaymentStatus.Not_Set,
      e.eDealPaymentStatus.DataError
    );
  }

  public static getPaymentLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "ePaymentMethod",
      e.ePaymentMethod.Not_Set,
      e.ePaymentMethod.DataError
    );
  }

  public static getPaymenMethodLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "ePaymentMethod",
      e.ePaymentMethod.Not_Set,
      e.ePaymentMethod.DataError
    );
  }

  public static getClientTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eClientType",
      e.eClientType.Not_Set,
      e.eClientType.DataError
    );
  }

  public static getContactTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactType",
      e.eContactType.Not_Set,
      e.eContactType.DataError
    );
  }

  public static getBuyerCategoryLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBuyerCategory",
      e.eBuyerCategory.Not_Set,
      e.eBuyerCategory.DataError
    );
  }
  public static getContactCategoryLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactCategory",
      e.eContactCategory.Not_Set,
      e.eContactCategory.DataError
    );
  }

  public static getBuyerNotificationMethodLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBuyerNotificationMethod",
      e.eBuyerNotificationMethod.Not_Set,
      e.eBuyerNotificationMethod.DataError
    );
  }

  public static getRepresentationCompanyLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBusinessUnit",
      e.eBusinessUnit.DataError,
      e.eBusinessUnit.Not_Set
    );
  }

  public static getOfficeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eOffice",
      e.eOffice.Not_Set,
      e.eOffice.DataError
    );
  }
  public static getFrequencyTypesLu(): SelectItem[] {
    return this.enumValues(e.eFrequencyType, e.eFrequencyType.Note_Set);
  }

  public static getClientDepartmentsLu(): SelectItem[] {
    return this.enumValues(
      e.eClientDepartment,
      e.eClientDepartment.Not_Set,
      e.eClientDepartment.DataError
    );
  }

  public static getClientStatusLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eClientStatus",
      e.eClientStatus.Not_Set,
      e.eClientStatus.DataError
    );
  }

  public static getContactStatusLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactStatus",
      e.eContactStatus.Not_Set,
      e.eContactStatus.DataError
    );
  }

  public static getDealStatusLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealStatus",
      e.eDealStatus.Not_Set,
      e.eDealStatus.DataError
    );
  }
  public static getDealTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealType",
      e.eDealType.Not_Set,
      e.eDealType.DataError
    );
  }
  public static getDealCrossCollateralizationLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealCrossCollateralizedLevel",
      e.eDealCrossCollateralizedLevel.Not_Set,
      e.eDealCrossCollateralizedLevel.DataError
    );
  }

  public static getClientTitleLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactTitle",
      e.eContactTitle.Not_Set,
      e.eContactTitle.DataError
    );
  }

  public static getWorkTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactWorkType",
      e.eContactWorkType.Not_Set,
      e.eContactWorkType.DataError
    );
  }

  public static getWorkAreaLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactWorkArea",
      e.eContactWorkArea.Not_Set,
      e.eContactWorkArea.DataError
    );
  }

  public static getAgeRangeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactAgeRange",
      e.eContactAgeRange.Not_Set,
      e.eContactAgeRange.DataError
    );
  }
  public static getRepTerretoriesLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eRegion",
      e.eRegion.Not_Set,
      e.eRegion.DataError
    );
  }

  public static getLiteraryLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eClientGenreLiterary",
      e.eClientGenreLiterary.Not_Set,
      e.eClientGenreLiterary.DataError
    );
  }

  public static getFilmTeleLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eClientGenreFilmAndTv",
      e.eClientGenreFilmAndTv.Not_Set,
      e.eClientGenreFilmAndTv.DataError
    );
  }

  public static getMusicLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eClientGenreMusic",
      e.eClientGenreMusic.Not_Set,
      e.eClientGenreMusic.DataError
    );
  }

  public static getEthnicityLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eEthnicity",
      e.eEthnicity.Not_Set,
      e.eEthnicity.DataError
    );
  }

  public static getCitizenshipLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eCitizenship",
      e.eCitizenship.Not_Set,
      e.eCitizenship.DataError
    );
  }
  public static getDealPositionLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealPosition",
      e.eDealPosition.Not_Set,
      e.eDealPosition.DataError,
      e.eDealPosition.Position
    );
  }

  public static getNationalityLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eNationality",
      e.eNationality.Not_Set,
      e.eNationality.DataError
    );
  }

  public static getContactPhoneTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactPhoneType",
      e.eContactPhoneType.Not_Set,
      e.eContactPhoneType.DataError
    );
  }

  public static getBuyerPhoneTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBuyerPhoneType",
      e.eBuyerPhoneType.Not_Set,
      e.eBuyerPhoneType.DataError
    );
  }

  public static getContactEmailTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactEmailType",
      e.eContactPhoneType.Not_Set,
      e.eContactPhoneType.DataError
    );
  }

  public static getBuyerEmailTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBuyerEmailType",
      e.eBuyerEmailType.Not_Set,
      e.eBuyerEmailType.DataError
    );
  }

  public static getGenderLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eGender",
      e.eGender.Not_Set,
      e.eGender.DataError
    );
  }

  public static getBBusinessUnitLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBusinessUnit",
      e.eBusinessUnit.Not_Set,
      e.eBusinessUnit.DataError
    );
  }

  public static getBuyerMarketLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBuyerMarket",
      e.eBuyerMarket.Not_Set,
      e.eBuyerMarket.DataError
    );
  }

  public static getSecurityRoleLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown("eUserRole", e.eUserRole.Not_Set);
  }

  public static getEmplpoyeeTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eUserType",
      e.eUserType.DataError,
      e.eUserType.Not_Set
    );
  }

  public static getBusinessUnitLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eBusinessUnit",
      e.eBusinessUnit.DataError,
      e.eBusinessUnit.Not_Set
    );
  }

  public static getNotifyLevel(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eClientNotifyLevel",
      e.eClientNotifyLevel.Not_Set,
      e.eClientNotifyLevel.DataError
    );
  }

  public static getBookingEngagementTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealBookingType",
      e.eDealBookingType.DataError,
      e.eDealBookingType.Not_Set
    );
  }

  public static getDealCompensationTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealCompensationType",
      e.eDealCompensationType.DataError,
      e.eDealCompensationType.Not_Set
    );
  }

  public static getDealContactTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealContactType",
      e.eDealCompensationType.DataError,
      e.eDealCompensationType.Not_Set
    );
  }

  public static getDealBuyerAssociateTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealBuyerAssociate",
      e.eDealBuyerAssociate.DataError
    );
  }

  public static getDealCurrencyExchangeTermLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealCurrencyExchangeTerm",
      e.eDealCurrencyExchangeTerm.DataError,
      e.eDealCurrencyExchangeTerm.Not_Set
    );
  }

  public static getItineraryTypes(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eItineraryType",
      e.eItineraryType.Not_Set,
      e.eItineraryType.DataError
    );
  }

  public static getItineraryEditableTypes(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eItineraryType",
      e.eItineraryType.Not_Set,
      e.eItineraryType.DataError,
      e.eItineraryType.Confirmed_Private,
      e.eItineraryType.Confirmed,
      e.eItineraryType.Pending_Private,
      e.eItineraryType.Pending,
      e.eItineraryType.Holiday,
      e.eItineraryType.Hold
    );
  }
  public static getCurrencyTypes(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eCurrency",
      e.eCurrency.Not_Set,
      e.eCurrency.DataError
    );
  }
  public static getUnitsOfDistance(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eRadiusUnit",
      e.eRadiusUnit.DataError,
      e.eRadiusUnit.Not_Set
    );
  }

  public static getDealMerchRateTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealMerchRateType",
      e.eDealMerchRateType.DataError,
      e.eDealMerchRateType.Not_Set
    );
  }
  public static getTicketTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealTicketType",
      e.eDealTicketType.DataError,
      e.eDealTicketType.Not_Set
    );
  }
  public static getDealShowScheduleTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealShowScheduleType",
      e.eDealShowScheduleType.DataError,
      e.eDealShowScheduleType.Not_Set
    );
  }
  public static getDealPaymentTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealPaymentType",
      e.eDealPaymentType.DataError,
      e.eDealPaymentType.Not_Set
    );
  }
  public static getDealTicketFeeTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealTicketFeeType",
      e.eDealTicketFeeType.DataError,
      e.eDealTicketFeeType.Not_Set
    );
  }
  public static getAttachmentTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eContactAttachmentType",
      e.eContactAttachmentType.Not_Set
    );
  }
  public static getDealAttachmentTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      e.eDealAttachmentType,
      e.eDealTicketFeeType.DataError
    );
  }

  public static getSellersTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealMerchRateWhoSells",
      e.eDealMerchRateWhoSells.Not_Set,
      e.eDealMerchRateWhoSells.DataError
    );
  }
  public static getDealCorrespondenceNoteTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealCorrespondenceNoteType",
      e.eDealCorrespondenceNoteType.Not_Set,
      e.eDealCorrespondenceNoteType.DataError
    );
  }
  public static getTimeZoneLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTimeZone",
      e.eTimeZone.Not_Set,
      e.eTimeZone.DataError
    );
  }

  public static geteItineraryClientListTypesLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eItineraryClientListTypes",
      e.eItineraryClientListTypes.All
    );
  }

  public static getItineraryExternalCalendersTypesLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eExternalCalendarImportType",
      e.eExternalCalendarImportType.Url
    );
  }

  public static getTvPckgGenreLu(type: e.eTvPckgDepartment): SelectItem[] {
    if (type === e.eTvPckgDepartment.TV_Scripted) {
      return LookUps.getEnumValuesForDropdown(
        "eTvPckgGenreTVScripted",
        e.eTvPckgGenreTVScripted.Not_Set,
        e.eTvPckgGenreTVScripted.DataError
      );
    } else if (type === e.eTvPckgDepartment.TV_NonScripted) {
      return LookUps.getEnumValuesForDropdown(
        "eTvPckgGenreTVNonScripted",
        e.eTvPckgGenreTVNonScripted.Not_Set,
        e.eTvPckgGenreTVNonScripted.DataError
      );
    } else if (type === e.eTvPckgDepartment.Digital) {
      return LookUps.getEnumValuesForDropdown(
        "eTvPckgGenreDigital",
        e.eTvPckgGenreDigital.Not_Set,
        e.eTvPckgGenreDigital.DataError
      );
    }

    return [];
  }

  public static getTvPckgLengthLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgLength",
      e.eTvPckgLength.Not_Set,
      e.eTvPckgLength.DataError
    );
  }

  public static getTvPckgAgencyLu(onlyActiveValues: boolean = false): SelectItem[] {

    return onlyActiveValues ?
      LookUps.getActiveEnumValuesForDropdown(
        "eTvPckgAgency",
        e.eTvPckgAgency.Not_Set
      ) :
      LookUps.getEnumValuesForDropdown(
        "eTvPckgAgency",
        e.eTvPckgAgency.Not_Set
      )
  }

  public static getTvPckgPckgBeOwnerLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgBeOwner",
      e.eTvPckgBeOwner.Not_Set,
      e.eTvPckgBeOwner.DataError
    );
  }

  public static getTvPckgBeStatusLu(): SelectItem[] {
    return Functions.sortByLabel([
      { value: 1, label: "None" },
      { value: 2, label: "Unsure/Unlikely" },
      { value: 3, label: "Expected" },
      { value: 4, label: "Active" },
      { value: 5, label: "Extinguished" }
    ]);
  }

  public static getTvPckgDepartmentLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgDepartment",
      e.eTvPckgDepartment.Not_Set,
      e.eTvPckgDepartment.DataError
    );
  }

  public static getTvPckgOutletTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgOutletType",
      e.eTvPckgOutletType.Not_Set,
      e.eTvPckgOutletType.DataError
    );
  }

  public static getTvPckgTvSeasonLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgTvBooking",
      e.eTvPckgTvBooking.Not_Set,
      e.eTvPckgTvBooking.DataError
    );
  }

  public static getTvPckgSeasonStatusLu(): SelectItem[] {
    return Functions.sortByLabel([
      { value: 1, label: "Completed" },
      { value: 2, label: "In Production" },
      { value: 3, label: "Pre-Production" },
      { value: 4, label: "Ordered" },
      { value: 5, label: "Projected" }
    ]);
  }

  public static getTvPckgNoteLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgNoteType",
      e.eTvPckgNoteType.Not_Set,
      e.eTvPckgNoteType.DataError
    );
  }

  public static getTvPckgPositionLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgPosition",
      e.eTvPckgPosition.Not_Set,
      e.eTvPckgPosition.DataError
    );
  }

  public static getTvPckgShareTypeLu(): SelectItem[] {
    return [
      { value: 1, label: "Full" },
      { value: 11, label: "3/4" },
      { value: 2, label: "2/3" },
      { value: 3, label: "60%" },
      { value: 4, label: "1/2" },
      { value: 6, label: "40%" },
      { value: 7, label: "1/3" },
      { value: 8, label: "1/4" },
      { value: 9, label: "Other" },
      { value: 10, label: "OUT" }
    ];
  }
  public static getTvPckgPackageStatusLu(): SelectItem[] {
    return Functions.sortByLabel(
      LookUps.getEnumValuesForDropdown(
        "eTvPckgPackageStatus",
        e.eTvPckgPackageStatus.Not_Set,
        e.eTvPckgPackageStatus.DataError
      )
    );
  }

  public static getTvPckgProjectStatusLu(): SelectItem[] {
    return Functions.sortByLabel(
      LookUps.getEnumValuesForDropdown(
        "eTvPckgProjectStatus",
        e.eTvPckgProjectStatus.Not_Set,
        e.eTvPckgProjectStatus.DataError
      )
    );
  }

  public static getTvPckgSplitStatusLu(): SelectItem[] {
    return [
      { value: 1, label: "Open" },
      { value: 2, label: "Closed" },
      { value: 3, label: "N/A" }
    ];
  }

  public static getTvPckgPaymentStatusLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgPaymentStatus",
      e.eTvPckgPaymentStatus.Not_Set,
      e.eTvPckgPaymentStatus.DataError
    );
  }

  public static getTvPckgElementStatusLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgElementStatus",
      e.eTvPckgElementStatus.Not_Set,
      e.eTvPckgElementStatus.DataError
    );
  }

  public static getTvPckgElementsWorkTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgElementWorkType",
      e.eTvPckgElementWorkType.Not_Set,
      e.eTvPckgElementStatus.DataError
    );
  }

  public static getTvPckgSizeLu(): SelectItem[] {
    return [
      { value: 1, label: "Full" },
      { value: 2, label: "1/2" },
      { value: 3, label: "1/2 to Full" },
      { value: 4, label: "Other" },
      { value: 5, label: "1/3" }
    ];
  }

  public static getTvPckgNavTransactionStateLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgNavTransactionState",
      e.eTvPckgNavTransactionState.Not_Set,
      e.eTvPckgNavTransactionState.DataError
    );
  }

  public static getTvPckgNavServiceTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgNavServiceType",
      e.eTvPckgNoteSender.Not_Set,
      e.eTvPckgNavServiceType.DataError
    );
  }

  public static getBeTvPckgNavServiceTypeLu(): SelectItem[] {
    LookUps.EnumType = this.getEnumByName("eTvPckgNavServiceType");
    const result: SelectItem[] = [];

    try {
      LookUps.EnumType.EnumValues.forEach(item => {
        if (/\|32(1|0)\|/.test(item.Description)) {
          result.push({
            value: item.Id,
            label: item.Value
          });
        }
      });
    } catch (error) { }

    return result;
  }

  public static getTvPckgNoteSenderTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTvPckgNoteSender",
      e.eTvPckgNoteSender.Not_Set
    );
  }

  public static getTvPckgTmsBookingStatusLu(removeDescriptionFor: any[] = null): SelectItem[] {
    let values =  LookUps.getEnumValuesForDropdown(
      "eTvPckgTmsBookingStatus",
    );

    values.find(_=>_.value == e.eTvPckgTmsBookingStatus.Pending).title = "Default value for Booking Status.";
    values.find(_=>_.value == e.eTvPckgTmsBookingStatus.Confirmed).title = "Season Status must be one of In Production, Pre Production, Ordered.";
    values.find(_=>_.value == e.eTvPckgTmsBookingStatus.Cancelled).title = "Possible, when no money are applied.";

    if (removeDescriptionFor) {
      values.forEach(item => {
        if (removeDescriptionFor.some(_ => _ == item.value)) {
          item.title = null;
        }
      });
    }

    return values;
  }

  // Tv10Percent Bookings
  public static getTv10PercentPaymentMethods(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentPaymentMethod",
      e.eTv10PercentPaymentMethod.Not_Set,
      e.eTv10PercentPaymentMethod.DataError
    );
  }

  public static getTv10PercentPaymentTypes(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentPaymentType",
      e.eTv10PercentPaymentType.Not_Set,
      e.eTv10PercentPaymentType.DataError
    );
  }

  public static getTv10PercentPaymentStatus(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentPaymentStatus",
      e.eTv10PercentPaymentStatus.Not_Set,
      e.eTv10PercentPaymentStatus.DataError
    );
  }

  public static getTv10PercentBookingStatusLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentBookingStatus",
      e.eTv10PercentBookingStatus.Not_Set,
      e.eTv10PercentBookingType.DataError
    );
  }

  public static getTv10PercentBookingTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentBookingType",
      e.eTv10PercentBookingType.Not_Set,
      e.eTv10PercentBookingType.DataError
    );
  }

  public static getTv10PercentCategoryLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentBookingCategory",
      e.eTv10PercentBookingCategory.Not_Set,
      e.eTv10PercentBookingType.DataError
    );
  }

  public static getTv10PercentBookingNoteTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentBookingNoteType",
      e.eTv10PercentBookingNoteType.Not_Set,
      e.eTv10PercentBookingNoteType.DataError
    );
  }

  public static getTv10PercentLengthLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentLength",
      e.eTv10PercentLength.Not_Set,
      e.eTv10PercentBookingType.DataError
    );
  }

  public static getTv10PercentFormatLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentFormat",
      e.eTv10PercentFormat.Not_Set,
      e.eTv10PercentBookingType.DataError
    );
  }

  public static getTv10PercentLevelLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentLevel",
      e.eTv10PercentLevel.Not_Set,
      e.eTv10PercentBookingType.DataError
    );
  }

  public static getTv10AttachmentTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentAttachmentType",
      e.eTv10PercentAttachmentType.Not_Set
    );
  }
  public static getTv10PositionTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eTv10PercentPosition",
      e.eTv10PercentPosition.Not_Set,
      e.eTv10PercentPosition.DataError
    );
  }

  public static getDealSubTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealSubType",
      e.eDealSubType.DataError,
      e.eDealSubType.Not_Set
    );
  }

  public static getDealEventTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealEventType",
      e.eDealEventType.DataError,
      e.eDealEventType.Not_Set
    );
  }

  public static getDealEventSubTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eDealEventSubType",
      e.eDealEventSubType.DataError,
      e.eDealEventSubType.Not_Set
    );
  }
  public static getVenueTypeLu(): SelectItem[] {
    return LookUps.getEnumValuesForDropdown(
      "eVenueType",
      e.eVenueType.DataError,
      e.eVenueType.Not_Set
    );
  }

  public static getRcCountryLu(): CountryDto[] {
    return LookUps.CountryList;
  }

  private static enumValues(value, ...excludedValues): SelectItem[] {
    return Functions.IterateEnum(value, excludedValues).sort((v1, v2) => {
      // tslint:disable-next-line:max-line-length
      return v1.label.toLowerCase().localeCompare(v2.label.toLowerCase()) >
        v2.label.toLowerCase().localeCompare(v1.label.toLowerCase())
        ? 1
        : v1.label.toLowerCase().localeCompare(v2.label.toLowerCase()) <
          v2.label.toLowerCase().localeCompare(v1.label.toLowerCase())
          ? -1
          : 0;
    });
  }
}
